<template>
  <div class="transRecord">
    <el-dialog
      width="800px"
      :visible.sync="dialog.show"
      :close-on-click-modal="dialog.clickModal"
      :close-on-press-escape="dialog.pressEscape"
      :before-close="handleClose"
      :modal-append-to-body="false"
    >
      <el-tabs tab-position="top">
        <el-tab-pane label="销售开单">
          <div>
            <el-form :model="transData" :rules="rules" ref="ruleForm" label-width="100px">
              <el-form-item label="客户姓名" prop="name">
                <el-input v-model="name" disabled></el-input>
              </el-form-item>
              <el-form-item label="产品类型" prop="type">
                <el-select
                  v-model="transData.type"
                  placeholder="请选择产品类型"
                  @change="onChangeStripe"
                >
                  <el-option label="成镜" value="1"></el-option>
                  <el-option label="隐形眼镜" value="2"></el-option>
                  <el-option label="太阳镜" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item v-if="childShow" label="隐形眼镜" prop="childType">
                <el-select
                  v-model="transData.childType"
                  placeholder="请选择隐形眼镜类型"
                >
                  <el-option label="月抛" value="1"></el-option>
                  <el-option label="季抛" value="2"></el-option>
                  <el-option label="半年抛" value="3"></el-option>
                  <el-option label="年抛" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="价格" prop="price">
                <el-input
                  placeholder="请输入价格"
                  v-model="transData.price"
                  maxlength="10"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="备注" prop="transRemark">
                <el-input
                  type="text"
                  v-model="transData.transRemark"
                ></el-input>
              </el-form-item>
              <el-form-item label="验光单" class="voucherBtn">
                <el-button
                  icon="el-icon-plus"
                  circle
                  @click="addVoucher"
                ></el-button>
                <el-tag
                  v-for="tag in transData.vouchers"
                  :key="tag.name"
                  effect="plain"
                  size="medium"
                  @close="tagClose(tag)"
                  closable
                >
                  {{ tag.name }}
                </el-tag>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item>
                <el-button class="btnTrans" type="primary" plain size="mini" @click="addOrder"
                  >开单</el-button
                >
                <el-button class="btnReset" plain size="mini" @click="resetForm"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog
      width="780px"
      :visible.sync="voucherDialog.show"
      :close-on-click-modal="voucherDialog.clickModal"
      :close-on-press-escape="voucherDialog.pressEscape"
      :before-close="handleClose"
      :modal-append-to-body="false"
    >
      <eye-voucher operation="add" @created="voucherEvent"></eye-voucher>
    </el-dialog>
  </div>
</template>

<script>
import EyeVoucher from "./EyeVoucher.vue";
import { addOrder } from "@/api/index";

export default {
  name: "transRecord",
  props: {
    dialog: Object,
    id: Number,
    name: String
  },
  components: {
    EyeVoucher
  },
  data() {
    return {
      childShow: false,
      transData: {
        type: "",
        childType: "0",
        price: null,
        transRemark: "",
        vouchers: []
      },
      voucherDialog: {
        show: false,
        clickModal: false,
        pressEscape: true
      },
       rules: {
          type: [
            { required: true, message: '请选择产品类型', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请输入订单价格', trigger: 'blur' }
          ]
        }
    };
  },
  methods: {
    onChangeStripe:function(e){
      if (this.transData.type == '2') {
        this.transData.childType = "1"
        this.childShow = true
      } else {
        this.childShow = false
        this.transData.childType = ""
      }
    },
    handleClose(done) {
      this.resetForm();
      done();
    },
    resetForm() {
      this.transData.transDate = null;
      this.transData.type = "";
      this.childShow = false
      this.transData.childType = "";
      this.transData.price = null;
      this.transData.transRemark = "";
      this.transData.vouchers = []
    },
    addOrder(){
      this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            addOrder({
              memberId: this.id,
              type: this.transData.type,
              childType: this.transData.childType,
              price: this.transData.price,
              remark: this.transData.transRemark,
              voucherId: (this.transData.vouchers != null && this.transData.vouchers.length > 0)?this.transData.vouchers[0].value:null
            }).then(res => {
              if (res.success == true) {
                this.resetForm()
                this.$refs['ruleForm'].resetFields();
                this.$emit("result");
              } else {
                this.$notify.error({
                  title: '错误',
                  message: res.message
                })
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    addVoucher() {
      if (this.transData.vouchers.length > 0) {
        this.$notify({
          title: '提示',
          message: '已经存在一张验光单，请先删除',
          type: 'warning'
        })
        return
      }
      this.voucherDialog.show = true
    },
    voucherEvent(data) {
      this.voucherDialog.show = false
      this.transData.vouchers = [{ name: "验光单", value: data }]
    },
    tagClose(tag) {
      this.transData.vouchers = []
    }
  },
  created() {}
};
</script>
<style lang="scss">
.transRecord {
  .el-dialog__headerbtn {
    z-index: 999;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__header {
    padding: 0px;
  }

  .btnTrans {
    position: absolute;
    right: 0px;
    bottom: -10px;
  }
  .btnReset {
    position: absolute;
    right: 60px;
    bottom: -10px;
  }
}
</style>
